import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {
  ColDef,
  GridApi,
  GridOptions,
  GridReadyEvent,
  IServerSideDatasource,
  IServerSideGetRowsParams,
} from 'ag-grid-community';

// COMPONENTS

// CONFIG

// INTERFACES

// SERVICES
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { UiConfirmationDialogComponent } from 'v2/modules/ui';

import { CompanyShippingAddressDropdownActionCellRendererComponent } from '../company-shipping-address-dropdown-action-cell-renderer/company-shipping-address-dropdown-action-cell-renderer.component';

import { ClientShippingAddressService } from './../../../../../app/core/client/services/client-shipping-address.service';
import { ClientShippingAddress } from './../../../../../app/core/client/store/client.model';
import { BusinessAccountContactsService } from './../../../../../app/core/client-user/services/business-account-contacts.service';
import { ShippingAddressPopupFormComponent } from './../../../../../app/shared/components/clients/shipping-address-popup-form/shipping-address-popup-form.component';
import { SnackBarConfig } from './../../../shared/configs/snackbar.config';

// UTILS
import { AgGridUtils } from './../../../shared/util/ag-grid.utils';

@Component({
  selector: 'lum-company-shipping-addresses',
  templateUrl: './company-shipping-addresses.component.html',
  styleUrls: ['./company-shipping-addresses.component.scss'],
})
export class CompanyShippingAddressesComponent implements OnInit, OnDestroy {
  @Input()
  businessAccount :any;

  shippingAddress :ClientShippingAddress;

  columnDefs :ColDef[] = [
    {
      headerName: '',
      field: 'default',
      filter: 'agTextColumnFilter',
      width: 50,
      cellRenderer: (params :any) => {
        // If params.value is true return check icon else return empty string
        return params.value
          ? '<i class="fas fa-check-circle" style="color: green;"></i>'
          : '';
      },
    },
    {
      headerName: 'Company',
      field: 'companyName',
      filter: 'agTextColumnFilter',
      floatingFilter: true,
      sortable: true,
      filterParams: {
        filterOptions: ['contains'],
        defaultOption: 'contains',
        maxNumConditions: 1,
        debounceMs: 1000,
      },
    },
    {
      headerName: 'Address Line 1',
      field: 'address',
      filter: 'agTextColumnFilter',
      floatingFilter: true,
      sortable: true,
      filterParams: {
        filterOptions: ['contains'],
        defaultOption: 'contains',
        maxNumConditions: 1,
        debounceMs: 1000,
      },
    },
    {
      headerName: 'Address Line 2',
      field: 'addressLine2',
      filter: 'agTextColumnFilter',
      floatingFilter: true,
      sortable: true,
      filterParams: {
        filterOptions: ['contains'],
        defaultOption: 'contains',
        maxNumConditions: 1,
        debounceMs: 1000,
      },
    },
    {
      headerName: 'City',
      field: 'city',
      filter: 'agTextColumnFilter',
      floatingFilter: true,
      sortable: true,
      filterParams: {
        filterOptions: ['contains'],
        defaultOption: 'contains',
        maxNumConditions: 1,
        debounceMs: 1000,
      },
    },
    {
      headerName: 'State',
      field: 'state',
      filter: 'agTextColumnFilter',
      floatingFilter: true,
      sortable: true,
      filterParams: {
        filterOptions: ['contains'],
        defaultOption: 'contains',
        maxNumConditions: 1,
        debounceMs: 1000,
      },
    },
    {
      headerName: 'Country',
      field: 'country',
      filter: 'agTextColumnFilter',
      floatingFilter: true,
      sortable: true,
      filterParams: {
        filterOptions: ['contains'],
        defaultOption: 'contains',
        maxNumConditions: 1,
        debounceMs: 1000,
      },
    },
    {
      headerName: 'Zip Code',
      field: 'postalCode',
      filter: 'agTextColumnFilter',
      floatingFilter: true,
      sortable: true,
      filterParams: {
        filterOptions: ['contains'],
        defaultOption: 'contains',
        maxNumConditions: 1,
        debounceMs: 1000,
      },
    },
    {
      headerName: 'Account Number',
      field: 'accountNumber',
      filter: 'agTextColumnFilter',
      floatingFilter: true,
      sortable: true,
      filterParams: {
        filterOptions: ['contains'],
        defaultOption: 'contains',
        maxNumConditions: 1,
        debounceMs: 1000,
      },
    },
    {
      headerName: 'Shipping Type',
      field: 'shippingType',
      filter: 'agTextColumnFilter',
      floatingFilter: true,
      sortable: true,
      filterParams: {
        filterOptions: ['contains'],
        defaultOption: 'contains',
        maxNumConditions: 1,
        debounceMs: 1000,
      },
    },
    {
      headerName: 'First Name',
      field: 'firstName',
      filter: 'agTextColumnFilter',
      floatingFilter: true,
      sortable: true,
      filterParams: {
        filterOptions: ['contains'],
        defaultOption: 'contains',
        maxNumConditions: 1,
        debounceMs: 1000,
      },
    },
    {
      headerName: 'Last Name',
      field: 'lastName',
      filter: 'agTextColumnFilter',
      floatingFilter: true,
      sortable: true,
      filterParams: {
        filterOptions: ['contains'],
        defaultOption: 'contains',
        maxNumConditions: 1,
        debounceMs: 1000,
      },
    },
    {
      headerName: 'Phone',
      field: 'phoneNumber',
      filter: 'agTextColumnFilter',
      floatingFilter: true,
      sortable: true,
      filterParams: {
        filterOptions: ['contains'],
        defaultOption: 'contains',
        maxNumConditions: 1,
        debounceMs: 1000,
      },
    },
    {
      headerName: 'Email',
      field: 'email',
      filter: 'agTextColumnFilter',
      floatingFilter: true,
      sortable: true,
      filterParams: {
        filterOptions: ['contains'],
        defaultOption: 'contains',
        maxNumConditions: 1,
        debounceMs: 1000,
      },
    },
    {
      headerName: 'Notes',
      field: 'notes',
      filter: 'agTextColumnFilter',
      floatingFilter: true,
      sortable: true,
      filterParams: {
        filterOptions: ['contains'],
        defaultOption: 'contains',
        maxNumConditions: 1,
        debounceMs: 1000,
      },
    },
    {
      headerName: '',
      field: 'actions',
      cellRenderer: CompanyShippingAddressDropdownActionCellRendererComponent,
      cellRendererParams: {
        update: (data :ClientShippingAddress) => {
          this.shippingAddress = data;
          this.toggleShippingForm();
        },
        delete: (data :ClientShippingAddress) => {
          this.shippingAddress = data;
          this.onDelete();
        },
        setAsDefault: (data :ClientShippingAddress) => {
          this.shippingAddress = data;
          this.onSetAsDefault();
        },
      },
      pinned: 'right',
      width: 40,
      lockPosition: true,
      lockVisible: true,
      suppressColumnsToolPanel: true,
      suppressMenu: true,
      filter: false,
      sortable: false,
      resizable: false,
    },
  ];

  gridOptions :GridOptions = {
    rowModelType: 'serverSide',
    pagination: true,
    cacheBlockSize: 100,
    maxBlocksInCache: 100,
    paginationPageSize: 100,
    domLayout: 'autoHeight',
    enableBrowserTooltips: true,
  };

  private gridApi :GridApi;
  private onDestroy$ = new Subject<void>();

  constructor(
    private clientShippingAddressService :ClientShippingAddressService,
    private businessAccountContactsService :BusinessAccountContactsService,
    private modal :NgbModal,
    private dialog :MatDialog,
    private snackbar :MatSnackBar,
  ) {}

  ngOnInit() :void {
    this.businessAccountContactsService.get({
      businessAccountId: this.businessAccount?.id?.toString(),
      limit: '1000',
    });
  }

  ngOnDestroy() :void {
    this.onDestroy$.next(null);
    this.onDestroy$.complete();
  }

  onGridReady(params :GridReadyEvent) :void {
    this.gridApi = params.api;
    const datasource = this.getServerSideDatasource();
    this.gridApi.setServerSideDatasource(datasource);
    // this.attachEventListenersOnPageStateChange();
  }

  getServerSideDatasource() :IServerSideDatasource {
    return {
      getRows: (params :IServerSideGetRowsParams) => {
        this.clientShippingAddressService
          .getV2({
            businessAccountId: this.businessAccount?.id,
            params: AgGridUtils.mapQueryParams({
              params,
              paginationPageSize: this.gridOptions.paginationPageSize,
            }),
          })
          .pipe(takeUntil(this.onDestroy$))
          .subscribe((response) => {
            params.successCallback(response.data, response.meta.total);
          });
      },
    };
  }

  onCreateShippingAddress() :void {
    this.shippingAddress = null;
    this.toggleShippingForm();
  }

  toggleShippingForm() :void {
    // Resuse v1 modal
    // TODO: Refactor to use v2 modal
    const modalRef = this.modal.open(ShippingAddressPopupFormComponent, {
      size: 'lg',
    });
    modalRef.componentInstance.businessAccount = this.businessAccount;
    modalRef.closed.subscribe(() => {
      this.gridApi.refreshServerSideStore();
    });
    if (this.shippingAddress) {
      modalRef.componentInstance.shippingAddress = this.shippingAddress;
    }
  }

  onDelete() :void {
    this.dialog
      .open(UiConfirmationDialogComponent, {
        data: {
          title: 'Confirm',
          message: 'Are you sure to delete this shipping address?',
          confirmButtonText: 'Confirm delete',
        },
      })
      .afterClosed()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((result) => {
        if (result) {
          this.clientShippingAddressService
            .delete(this.businessAccount?.id, this.shippingAddress?.id)
            .pipe(takeUntil(this.onDestroy$))
            .subscribe(() => {
              this.snackbar.open('Deleted successfully.', 'Success', {
                duration: SnackBarConfig.DEFAULT.duration,
              });
              this.gridApi.refreshServerSideStore();
            });
        }
      });
  }

  onSetAsDefault() :void {
    this.clientShippingAddressService
      .setDefault(this.businessAccount?.id, this.shippingAddress?.id)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe({
        next: () => {
          this.snackbar.open('Set as default successfully.', 'Success', {
            duration: SnackBarConfig.DEFAULT.duration,
          });
        },
        error: (error) => {
          this.snackbar.open(
            error.error || 'Update error. Try again later.',
            'Error',
            {
              duration: SnackBarConfig.DEFAULT.duration,
            },
          );
        },
      });
  }

  getTooltip(params :any) :string {
    return params.value ? 'Default Shipping Address' : '';
  }
}
